'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth-store';
import {
  DISABLED_GOVERNMENT_INTEGRATIONS,
  type GovernmentIntegration,
  type GovernmentIntegrationEnablement,
} from '@/lib/integrations/government/enablement-types';

const Context = createContext({ tenantId: '', enabled: DISABLED_GOVERNMENT_INTEGRATIONS });

export function GovernmentIntegrationProvider({
  tenantId,
  enabled,
  children,
}: {
  tenantId: string;
  enabled: GovernmentIntegrationEnablement;
  children: ReactNode;
}) {
  return <Context.Provider value={{ tenantId, enabled }}>{children}</Context.Provider>;
}

export function useGovernmentIntegrations(): GovernmentIntegrationEnablement {
  const context = useContext(Context);
  const tenantId = useAuthStore((state) => state.user?.tenantId);
  return tenantId && tenantId === context.tenantId
    ? context.enabled
    : DISABLED_GOVERNMENT_INTEGRATIONS;
}

export function useGovernmentIntegrationEnabled(integration: GovernmentIntegration): boolean {
  return useGovernmentIntegrations()[integration] === true;
}
